export const ex = {
	name: 'ex',
	title: 'Ex',
	content:
		'<path d="M 11.998,0.75c6.213,0,11.25,5.037,11.25,11.25s-5.037,11.25-11.25,11.25S0.748,18.213,0.748,12 S5.785,0.75,11.998,0.75z " stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 7.498,16.5l8.999-9 " stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M 16.498,16.5l-9.001-9" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>',
};
